import { MypageNovelFrontispieceDeleteInputModel } from "./DeleteInputModel"
import { httpDelete } from "../../../../../../../libs/http/httpDelete"

const endpointUrl = "/v1/mypage/novel/{novelId}/frontispiece/{frontispieceId}"

export const deleteMypageNovelFrontispiece = (
  model: MypageNovelFrontispieceDeleteInputModel,
): Promise<void> => {
  return httpDelete<void>(endpointUrl, model)
}
